export default "__VITE_ASSET__xaxGhT$O__"